import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function Slot({ children, className, ...props }) {
    if (/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.isValidElement)(children)) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.cloneElement)(children, {
        ...props,
        ...children.props,
        style: {
            ...props.style,
            ...children.props.style
        },
        className: (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cx)(children.props.className, className)
    });
    if (__WEBPACK_EXTERNAL_MODULE_react__["default"].Children.count(children) > 1) __WEBPACK_EXTERNAL_MODULE_react__["default"].Children.only(null);
    return null;
}
const Slot_rslib_entry_ = Slot;
export { Slot_rslib_entry_ as default };

//# sourceMappingURL=Slot.js.map